import z from 'zod';
export const LEGAL_REPRESENTATIVE_GRAMMATICAL_GENDER = {
    FEMININE: 'feminine',
    MASCULINE: 'masculine',
};
export const LEGAL_REPRESENTATIVE_GENDER_ACCORD_BY_DOCX_VARIABLE = {
    REPRESENTANT_LEGAL_1_ACCORD_ANTERIEUR: {
        feminine: 'antérieure',
        masculine: 'antérieur',
    },
    REPRESENTANT_LEGAL_1_ACCORD_APPORTEUR: {
        feminine: 'Madame',
        masculine: 'Monsieur',
    },
    REPRESENTANT_LEGAL_1_ACCORD_ASSOCIE: {
        feminine: 'Associée',
        masculine: 'Associé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_ASSOCIE_UNIQUE: {
        feminine: 'L\'associée unique',
        masculine: 'L\'associé unique',
    },
    REPRESENTANT_LEGAL_1_ACCORD_CHARGE_CHARGEE: {
        feminine: 'chargée',
        masculine: 'chargé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_CONSCIENT: {
        feminine: 'Consciente',
        masculine: 'Conscient',
    },
    REPRESENTANT_LEGAL_1_ACCORD_CONVOQUE: {
        feminine: 'convoquée',
        masculine: 'convoqué',
    },
    REPRESENTANT_LEGAL_1_ACCORD_DESIGNATION_MAJ: {
        feminine: 'L\'Associée',
        masculine: 'L\'Associé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_DESIGNATION_MIN: {
        feminine: 'l\'associée',
        masculine: 'l\'associé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_DESIGNE: {
        feminine: 'désignée',
        masculine: 'désigné',
    },
    REPRESENTANT_LEGAL_1_ACCORD_DESIGNE_DESIGNEE: {
        feminine: 'désignée',
        masculine: 'désigné',
    },
    REPRESENTANT_LEGAL_1_ACCORD_DETENTEUR: {
        feminine: 'détentrice',
        masculine: 'détenteur',
    },
    REPRESENTANT_LEGAL_1_ACCORD_DEVENU: {
        feminine: 'Devenue',
        masculine: 'Devenu',
    },
    REPRESENTANT_LEGAL_1_ACCORD_DOMICILIE: {
        feminine: 'Domiciliée',
        masculine: 'Domicilié',
    },
    REPRESENTANT_LEGAL_1_ACCORD_ETABLI: {
        feminine: 'établie',
        masculine: 'établi',
    },
    REPRESENTANT_LEGAL_1_ACCORD_EXERCICE: {
        feminine: 'seule',
        masculine: 'seul',
    },
    REPRESENTANT_LEGAL_1_ACCORD_FILIATION: {
        feminine: 'Née',
        masculine: 'Né',
    },
    REPRESENTANT_LEGAL_1_ACCORD_FONCTIONS: {
        feminine: 'Présidente',
        masculine: 'Président',
    },
    REPRESENTANT_LEGAL_1_ACCORD_FRAPPE: {
        feminine: 'frappée',
        masculine: 'frappé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_GERANT: {
        feminine: 'La gérante',
        masculine: 'Le gérant',
    },
    REPRESENTANT_LEGAL_1_ACCORD_HABILITE: {
        feminine: 'habilitée',
        masculine: 'habilité',
    },
    REPRESENTANT_LEGAL_1_ACCORD_INFORME: {
        feminine: 'informée',
        masculine: 'informé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_INSCRIT: {
        feminine: 'inscrite',
        masculine: 'inscrit',
    },
    REPRESENTANT_LEGAL_1_ACCORD_INVESTI: {
        feminine: 'investie',
        masculine: 'investi',
    },
    REPRESENTANT_LEGAL_1_ACCORD_MARIE: {
        feminine: 'Mariée',
        masculine: 'Marié',
    },
    REPRESENTANT_LEGAL_1_ACCORD_MIS: {
        feminine: 'mise',
        masculine: 'mis',
    },
    REPRESENTANT_LEGAL_1_ACCORD_NE_NEE: {
        feminine: 'Née',
        masculine: 'Né',
    },
    REPRESENTANT_LEGAL_1_ACCORD_NOMME: {
        feminine: 'nommée',
        masculine: 'nommé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_NOUVEL: {
        feminine: 'nouvelle',
        masculine: 'nouvel',
    },
    REPRESENTANT_LEGAL_1_ACCORD_PRESENCE: {
        feminine: 'représentée',
        masculine: 'représenté',
    },
    REPRESENTANT_LEGAL_1_ACCORD_PRESIDENT: {
        feminine: 'La présidente',
        masculine: 'Le président',
    },
    REPRESENTANT_LEGAL_1_ACCORD_PRONOM: {
        feminine: 'Elle',
        masculine: 'Il',
    },
    REPRESENTANT_LEGAL_1_ACCORD_QUITUS: {
        feminine: 'à la présidente',
        masculine: 'au président',
    },
    REPRESENTANT_LEGAL_1_ACCORD_RENONCANT: {
        feminine: 'renonçante',
        masculine: 'renonçant',
    },
    REPRESENTANT_LEGAL_1_ACCORD_REPRESENTE: {
        feminine: 'Représentée',
        masculine: 'Représenté',
    },
    REPRESENTANT_LEGAL_1_ACCORD_REPUTE: {
        feminine: 'réputée',
        masculine: 'réputé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_SECRETAIRE: {
        feminine: 'La secrétaire',
        masculine: 'Le secrétaire',
    },
    REPRESENTANT_LEGAL_1_ACCORD_SEUL: {
        feminine: 'seule',
        masculine: 'seul',
    },
    REPRESENTANT_LEGAL_1_ACCORD_SIGNE: {
        feminine: 'signée',
        masculine: 'signé',
    },
    REPRESENTANT_LEGAL_1_ACCORD_SOUSSIGNE: {
        feminine: 'Je soussignée',
        masculine: 'Je soussigné',
    },
    REPRESENTANT_LEGAL_1_ACCORD_TENU: {
        feminine: 'tenue',
        masculine: 'tenu',
    },
    REPRESENTANT_LEGAL_2_ACCORD_DETENTEUR: {
        feminine: 'détentrice',
        masculine: 'détenteur',
    },
    REPRESENTANT_LEGAL_2_ACCORD_DOMICILIE: {
        feminine: 'Domiciliée',
        masculine: 'Domicilié',
    },
    REPRESENTANT_LEGAL_2_ACCORD_FILIATION: {
        feminine: 'fille',
        masculine: 'fils',
    },
    REPRESENTANT_LEGAL_2_ACCORD_FILS_FILLE: {
        feminine: 'fille',
        masculine: 'fils',
    },
    REPRESENTANT_LEGAL_2_ACCORD_FRAPPE: {
        feminine: 'frappée',
        masculine: 'frappé',
    },
    REPRESENTANT_LEGAL_2_ACCORD_GENRE: {
        feminine: 'associée',
        masculine: 'associé',
    },
    REPRESENTANT_LEGAL_2_ACCORD_NE_NEE: {
        feminine: 'née',
        masculine: 'né',
    },
    REPRESENTANT_LEGAL_2_ACCORD_NOMME: {
        feminine: 'nommée présidente',
        masculine: 'nommé président',
    },
    REPRESENTANT_LEGAL_2_ACCORD_PRESENCE: {
        feminine: 'présente / représentée',
        masculine: 'présent / représenté',
    },
    REPRESENTANT_LEGAL_2_ACCORD_PRESIDENT: {
        feminine: 'La Présidente',
        masculine: 'Le Président',
    },
    REPRESENTANT_LEGAL_2_ACCORD_REPRESENTE: {
        feminine: 'représentée',
        masculine: 'représenté',
    },
    REPRESENTANT_LEGAL_2_ACCORD_SOUSSIGNE: {
        feminine: 'Je soussignée',
        masculine: 'Je soussigné',
    },
    REPRESENTANT_LEGAL_3_ACCORD_DETENTEUR: {
        feminine: 'détentrice',
        masculine: 'détenteur',
    },
    REPRESENTANT_LEGAL_3_ACCORD_GENRE: {
        feminine: 'associée',
        masculine: 'associé',
    },
    REPRESENTANT_LEGAL_3_ACCORD_PRESENCE: {
        feminine: 'présente / représentée',
        masculine: 'présent / représenté',
    },
    REPRESENTANT_LEGAL_4_ACCORD_DESIGNE: {
        feminine: 'désignée',
        masculine: 'désigné',
    },
    REPRESENTANT_LEGAL_4_ACCORD_FRAPPE: {
        feminine: 'frappée',
        masculine: 'frappé',
    },
    REPRESENTANT_LEGAL_4_ACCORD_GENRE: {
        feminine: 'Présidente',
        masculine: 'Président',
    },
    REPRESENTANT_LEGAL_4_ACCORD_GERANT: {
        feminine: 'La gérante',
        masculine: 'Le gérant',
    },
    REPRESENTANT_LEGAL_4_ACCORD_NOMME: {
        feminine: 'nommée',
        masculine: 'nommé',
    },
};
const legalRepresentativeGenderAccordDocxVariableValues = Object.keys(LEGAL_REPRESENTATIVE_GENDER_ACCORD_BY_DOCX_VARIABLE);
export const legalRepresentativeGenderAccordDocxVariableValue = z.enum(legalRepresentativeGenderAccordDocxVariableValues);
export const legalRepresentativeGenderAccordDocxVariable = (value) => legalRepresentativeGenderAccordDocxVariableValue.parse(value);
export const isLegalRepresentativeGenderAccordDocxVariable = (value) => legalRepresentativeGenderAccordDocxVariableValue.safeParse(value).success;
const TITLE_OR_CIVILITY_TO_GENDER = {
    'M.': LEGAL_REPRESENTATIVE_GRAMMATICAL_GENDER.MASCULINE,
    Madame: LEGAL_REPRESENTATIVE_GRAMMATICAL_GENDER.FEMININE,
    Mme: LEGAL_REPRESENTATIVE_GRAMMATICAL_GENDER.FEMININE,
    Monsieur: LEGAL_REPRESENTATIVE_GRAMMATICAL_GENDER.MASCULINE,
};
export const resolveLegalRepresentativeGrammaticalGender = (titleOrCivilityLabel) => {
    if (titleOrCivilityLabel === null || titleOrCivilityLabel === undefined) {
        return null;
    }
    const trimmed = titleOrCivilityLabel.trim();
    if (trimmed.length === 0) {
        return null;
    }
    return TITLE_OR_CIVILITY_TO_GENDER[trimmed] ?? null;
};
export const resolveLegalRepresentativeGenderAccordValue = (docxKey, gender) => LEGAL_REPRESENTATIVE_GENDER_ACCORD_BY_DOCX_VARIABLE[docxKey][gender];
//# sourceMappingURL=legal-representative-gender-accord-mapping.js.map